import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=7c4974f0&scoped=true&lang=postcss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4974f0"]])

export default __exports__